import React from "react";
import DynamicViewTable from "./DynamicViewTable";
import Popup from "reactjs-popup";
import { challanApiConfig } from "../config/apiConfig.js";
import LoadingOverlay from "react-loading-overlay";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useRef, useState } from "react";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import ReportExcel from "./ReportExcel.js";

// import { saveAs } from 'file-saver'

import print from "print-js";
import {
  groupInfo,
  dataObject,
  challanBiltyOriginalTableHeader,
  challanBiltyOriginalTableItems,
  validate,
  popupInfo,
} from "../config/challanForm.js";
import DatePicker from "react-datepicker";
import {
  NEW_PRINT,
  SERVER_URL,
  USE_OVERLAY,
} from "../config/config";
import { Prompt } from "react-router-dom";
import Autosuggest from "react-autosuggest";
import "./Form.css";
import "./ChallanForm.css";
import "./AutoSuggest.css";
import useForm from "./useForm";
import "./popup.css";
import ReactToPrint from "react-to-print";
import TableToPrint from "./ChallanPrint";
import FormColumn from "./FormColumn.js";
import { useHistory } from "react-router-dom";
let checkCwbResult = {};

const ChallanForm = ({ sessionObject, itemNamesDict }) => {
  if (process.env.REACT_APP_CLIENT == "gdala_log") {
    const packingType = challanBiltyOriginalTableItems.find(
      (item) => item.name === "packing_type"
    );
    packingType.convertFunction = (itemObject) => {
      return itemNamesDict[String(itemObject.item_info[0].packing_type)];
    };
  }

  const history = useHistory();
  const location = useLocation();
  const [checkCwbSubmitted, setcheckCwbSubmitted] = React.useState(false);
  const [isPrint, setIsPrint] = React.useState(false);
  const [popupLoading, setPopupLoading] = React.useState(true);
  const [printData, setPrintData] = React.useState([]);
  const [destinationExtras, setDestinationExtras] = React.useState([]);
  const prevExtraDestsHash = React.useRef("");
  const [stationTo, setStationTo] = React.useState("");
  const contentStyle = {
    maxWidth: "600px",
    width: "90%",
  };

  useEffect(() => {
    const defaultChallanNo = location.state ?? "";
    if (defaultChallanNo != "") {
      myForm.setPageStateByField("challan_no", defaultChallanNo);

      const fakeKey = { key: "Enter" };
      // myForm.getPageOnKeyEnter(fakeKey, defaultChallanNo);
      myForm.setOverlay(true);
      let data = {
        apiUrlTail:
          defaultChallanNo + "?branch_id=" + myForm.pageState.created_from,
        apiType: "getChallan",
        apiConfig: challanApiConfig["getChallan"],
      };
      const fYear_fetch = JSON.parse(
        sessionStorage.getItem("financial_year_for_fetch")
      ).financial_year_for_fetch;
      data.apiUrlTail +=
        "&fyear=" + fYear_fetch + "&companyId=" + myForm.pageState.company_id;
      myForm.performSuggestions(data);
    }
  }, []);

  const [checked, setChecked] = useState(false);
  const handleChangeCheckbox = () => {
    myForm.pageState["is_crossing_challan"] = !checked;
    setChecked(!checked);
  };

  let variablesFromSession = {
    station_from: String(sessionObject.sessionVariables.branch_id),
    station_from_name: sessionObject.sessionVariables.branch_name,
    created_from: String(sessionObject.sessionVariables.branch_id),
    created_by: String(sessionObject.sessionVariables.user_id),
    role_id: String(sessionObject.sessionVariables.role_id),
    created_by_name: String(sessionObject.sessionVariables.user_name),
    company_id: sessionObject.sessionVariables.company_id ?? "1",
    fYear: sessionObject.sessionVariables.financial_year,
    branch_name: sessionObject.sessionVariables.branch_name,
    branch_mobile: sessionObject.sessionVariables.branch_mobile,
  };

  const myForm = useForm(
    "Challan",
    validate,
    { ...dataObject, ...variablesFromSession },
    challanApiConfig,
    itemNamesDict
  );

  const accountDetailTableHeader = [
    { label: "Sr. No.", className: "text-center table-header" },
    { label: "Debit Party Name", className: "text-center table-header" },
    { label: "Credit Party Name", className: "text-center table-header" },
    // { label: "Credit", className: "text-center table-header" },
    { label: "Amount", className: "text-center table-header" },
    { label: "Voucher Id", className: "text-center table-header" },
    { label: "Voucher Type", className: "text-center table-header" },
    { label: "Remarks", className: "text-center table-header" },
  ];

  const accountDetailTableItems = [
    // {
    //   type: "number",
    //   name: "credit",
    //   label: "Credit",
    //   className: "form-control-medlarge-col",
    // },
    {
      type: "text",
      name: "source_party_name",
      label: "Debit Party Name",
      className: "form-control-medlarge-col",
    },
    {
      type: "text",
      name: "party_name",
      label: "Credit Party Name",
      className: "form-control-medlarge-col",
    },
    {
      type: "number",
      name: "debit",
      label: "Amount",
      className: "form-control-medlarge-col",
    },
    {
      type: "number",
      name: "voucher_id",
      label: "Voucher Id",
      className: "form-control-medlarge-col",
    },
    {
      type: "text",
      name: "voucher_type",
      label: "Voucher Type",
      className: "form-control-medlarge-col",
    },
    {
      type: "text",
      name: "remarks",
      label: "Remarks",
      className: "form-control-medlarge-col",
    },
  ];

  const handleCheckboxChangeRR = (arr, item, idx) => {
    let dummyArray = printData;

    if (arr.target.checked) {
      dummyArray[idx].checked = "1";
    } else {
      dummyArray[idx].checked = "0";
    }
    setPrintData([...dummyArray]);
  };

  const deselectAllRR = () => {
    let dummyArray = printData;
    for (let i = 0; i < dummyArray.length; i++) {
      dummyArray[i].checked = "0";
    }
    setPrintData([...dummyArray]);
  };

  const selectAllRR = () => {
    let dummyArray = printData;
    for (let i = 0; i < dummyArray.length; i++) {
      dummyArray[i].checked = "1";
    }
    setPrintData([...dummyArray]);
  };

  const getSelectAllValueRR = () => {
    for (let i = 0; i < printData.length; i++) {
      if (printData[i].checked != "1") {
        return false;
      }
    }
    return true;
  };

  if (process.env.REACT_APP_CLIENT == "guru") {
    useEffect(() => {
      myForm.setPageState((oldState) => ({
        ...oldState,
        destination: myForm.pageState.station_to,
        destination_name: myForm.pageState.station_to_name,
      }));
    }, [myForm.pageState.station_to_name]);
  }

  useEffect(() => {
    const extraDests = [];
    for (let i = 0; ; i++) {
      const idField = `destination_${i}`;
      if (!(idField in myForm.pageState)) break;
      if (myForm.pageState[idField]) {
        extraDests.push({ nameField: `destination_${i}_name`, idField });
      }
    }
    const hash = extraDests.map(e => e.idField).join(",");
    if (hash && hash !== prevExtraDestsHash.current) {
      prevExtraDestsHash.current = hash;
      setDestinationExtras(extraDests);
    }
  }, [myForm.pageState]);

  if (process.env.REACT_APP_CLIENT === "xpress") {
    useEffect(() => {
      if (myForm.pageState.vehicle_no !== "") {
        fetch(`${SERVER_URL}/vehicle/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            additional_info: { is_active: 1 },
            companyId: myForm.pageState.company_id,
            limit: "10",
            vehicle_no: myForm.pageState.vehicle_no,
            search: "like",
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data && data.length > 0) {
              const {
                vehicle_id,
                vehicle_no,
                driver_name,
                owner_name,
                tds_rate,
              } = data[0];
              if (
                vehicle_id &&
                vehicle_no &&
                driver_name &&
                owner_name &&
                tds_rate
              ) {
                myForm.setPageState((oldState) => ({
                  ...oldState,
                  vehicle_id,
                  vehicle_no,
                  driver_name,
                  owner_name,
                  tds_rate,
                }));
              }
            }
          })
          .catch((error) => console.error("Error fetching data:", error));
      }
    }, [myForm.pageState.vehicle_no, myForm.pageState.company_id]);

    useEffect(() => {
      if (myForm.pageState.billing_party_name !== "") {
        const payload = {
          companyId: myForm.pageState.company_id,
          limit: "10",
          name: myForm.pageState.billing_party_name,
          search: "like",
        };
        fetch(SERVER_URL + "/consignee/", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data && data.length > 0) {
              const billing_party = data[0].consignee_id;
              myForm.setPageState((oldState) => ({
                ...oldState,
                billing_party: billing_party,
              }));
            }
          })
          .catch((error) => console.error("Error fetching data:", error));
      }
    }, [myForm.pageState.billing_party_name, myForm.pageState.company_id]);

    useEffect(() => {
      const fetchBranchData = (fieldName, fieldState, setState) => {
        if (fieldState !== "") {
          const payload = {
            additional_info: { is_branch: true },
            companyId: myForm.pageState.company_id,
            limit: "10",
            name: fieldState,
            search: "like",
          };
          fetch(`${SERVER_URL}/branch/`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          })
            .then((response) => response.json())
            .then((data) => {
              if (data && data.length > 0) {
                setState((oldState) => ({
                  ...oldState,
                  [fieldName]: data[0].branch_id,
                }));
              }
            })
            .catch((error) => console.error("Error fetching data:", error));
        }
      };

      fetchBranchData(
        "station_from",
        myForm.pageState.station_from_name,
        myForm.setPageState
      );
      fetchBranchData(
        "station_to",
        myForm.pageState.station_to_name,
        myForm.setPageState
      );
      fetchBranchData(
        "destination",
        myForm.pageState.destination_name,
        myForm.setPageState
      );
    }, [
      myForm.pageState.station_from_name,
      myForm.pageState.station_to_name,
      myForm.pageState.destination_name,
      myForm.pageState.company_id,
    ]);
  }

  const getAdditionalInfoForSuggestionFetch = (fieldInfoObject) => {
    let additionalInfoObject = {};
    if (fieldInfoObject.name == "station_from_name") {
      additionalInfoObject.is_branch = 0; // changed from true to 0
      return additionalInfoObject;
    }
    if (fieldInfoObject.name == "vehicle_no") {
      additionalInfoObject.is_active = "1";
      return additionalInfoObject;
    }
    return null;
  };

  const checkIfFieldAlreadyExists = (fieldKey, fieldValue, arrayToCheck) => {
    let dummyObject = {};
    for (let i = 0; i < arrayToCheck.length; i++) {
      dummyObject = arrayToCheck[i];
      if (fieldKey in dummyObject && dummyObject[fieldKey] == fieldValue) {
        return true;
      }
    }
    return false;
  };

  const getFyearsOnKeyEnter = async (e, myFormName, page_id) => {
    if (e.key == "Enter") {
      e.persist();
      myForm.setOverlay(true);
      myForm.setPageStateByField("enterEvent", { ...e });

      // refStoreObject.current[e.target.name].blur();

      const company_id = myForm.pageState.company_id;
      let url = SERVER_URL;
      let dataToSend = {};
      let finalFyearList = [];

      if (myFormName == "Bilty Inquiry") {
        myForm.refStoreObject.current["bilty_no"].blur();
        // if (page_id == "") {
        //     setOverlay(false);
        //     makeFocusOnParticularFieldForItem("eway_bill_no", 0, "eway_bill_no");
        //     return;
        // }
        url += "/bilty/option";

        let flag = 0;
        if (
          myForm.pageState.bilty_type == "c" ||
          myForm.pageState.bilty_type == "C"
        ) {
          flag = 1;
        }

        dataToSend = {
          companyId: company_id,
          bilty_no: page_id,
          suffix: null,
        };
        dataToSend.owned_by = myForm.pageState.created_from;
        dataToSend.branch_id = myForm.pageState.created_from;
        // myForm.pageState.billing_party ? dataToSend.billing_party  = myForm.pageState.billing_party : dataToSend.billing_party = null;
        dataToSend.module = "chalan";
        dataToSend.flag = flag;
      }

      const resp = await fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataToSend),
      });

      const respData = await resp.json();

      if (Array.isArray(respData)) {
        const fYearList = respData;

        fYearList.forEach((obj) => {
          if ("fyear" in obj) {
            finalFyearList.push(obj.fyear);
          }
        });
        finalFyearList.reverse();
        if (finalFyearList.length == 1) {
          myForm.getSuffixesOfBilty(page_id, finalFyearList[0]);
        } else {
          myForm.setPageStateByField("fyearList", finalFyearList);
        }
      } else {
        // got whole bilty
        if (!resp.ok) {
          const temp_error = respData;
          if ("detail" in temp_error) {
            if (temp_error.detail == "Docket not found") {
              myForm.makeFocusOnParticularField("bilty_no");
              myForm.setOverlay(false);
              return;
            }
            myForm.setPreviousPageMode(myForm.pageMode);
            myForm.setPageMode("error");
            myForm.setPopupError(String(temp_error.detail));
          } else {
            myForm.setPreviousPageMode(myForm.pageMode);
            myForm.setPageMode("error");
            myForm.setPopupError("Invalid Bilty");
          }
          myForm.setPageState({
            ...myForm.pageState,
            ["No"]: "",
            ["suffix"]: "",
          });
          myForm.setOverlay(false);
          return;
        }
        if (
          myForm.pageState.billing_party &&
          process.env.REACT_APP_CLIENT != "xpress"
        ) {
          if (
            process.env
              .REACT_APP_BILLING_PARTY_COMPULSORY_FROM_CONSIGNOR_CONSIGNEE ==
            "NRAB"
          ) {
            if (
              myForm.pageState.billing_party == respData.consignor_id ||
              respData.consignee_id
            ) {
              linkBilty({}, respData);
            } else {
              myForm.setPreviousPageMode(myForm.pageMode);
              myForm.setPageMode("error");
              myForm.setPopupError("Different billing party");
            }
          } else if (process.env.REACT_APP_CLIENT == "shubham") {
            if (myForm.pageState.billing_party == respData.billing_party) {
              linkBilty({}, respData);
            } else {
              myForm.setPreviousPageMode(myForm.pageMode);
              myForm.setPageMode("error");
              myForm.setPopupError("Different billing party");
            }
          } else {
            if (myForm.pageState.billing_party == respData.consignor_id) {
              linkBilty({}, respData);
            } else {
              myForm.setPreviousPageMode(myForm.pageMode);
              myForm.setPageMode("error");
              myForm.setPopupError("Different billing party");
            }
          }
        } else {
          // myForm.setPageState({
          //     ...myForm.pageState,
          //     vehicle_no:respData.vehicle_no
          // });
          // myForm.setPageStateByField("vehicle_no", respData.vehicle_no);
          linkBilty({}, respData);
        }
      }
      myForm.setOverlay(false);
    }
  };

  const linkBilty = async (e, argResponse) => {
    let temp_response;
    if (argResponse) {
      temp_response = argResponse;
    } else {
      if (myForm.pageState.No == "" && e.key == "Enter") {
        myForm.makeFocusOnParticularField("save_button");
        return;
      }
      if (e.key == "Enter") {
        let flag = 0;
        if (
          myForm.pageState.bilty_type == "c" ||
          myForm.pageState.bilty_type == "C"
        ) {
          flag = 1;
        }
        let suffix = myForm.pageState.suffix;
        if (suffix == "") {
          suffix = "null";
        }
        const url =
          SERVER_URL +
          "/bilty/chalan_in/" +
          myForm.pageState.No +
          "?branch_id=" +
          myForm.pageState.created_from +
          "&suffix=" +
          suffix +
          "&flag=" +
          flag +
          "&fyear=" +
          myForm.pageState.fyear_get_bilty +
          "&companyId=" +
          myForm.pageState.company_id;
        const response = await fetch(url);
        if (!response.ok) {
          const temp_error = await response.json();
          if ("detail" in temp_error) {
            if (temp_error.detail == "Docket not found") {
              myForm.makeFocusOnParticularField("bilty_no");
              return;
            }
            myForm.setPreviousPageMode(myForm.pageMode);
            myForm.setPageMode("error");
            myForm.setPopupError(String(temp_error.detail));
          } else {
            myForm.setPreviousPageMode(myForm.pageMode);
            myForm.setPageMode("error");
            myForm.setPopupError("Invalid Bilty");
          }
          myForm.setPageState({
            ...myForm.pageState,
            ["No"]: "",
            ["suffix"]: "",
          });
          return;
        }
        temp_response = await response.json();
      }
    }

    // if("flag" in temp_response) {
    //     myForm.makeFocusOnParticularField("suffix");
    //     return;
    // }

    if (temp_response.check_fail) {
      myForm.setPageState({
        ...myForm.pageState,
        ["No"]: "",
        ["suffix"]: "",
      });
      myForm.setPreviousPageMode(myForm.pageMode);
      myForm.setPageMode("error");
      myForm.setPopupError("Not possible to add this bilty");
      return;
    }
    if (
      checkIfFieldAlreadyExists(
        "bilty_id",
        temp_response.bilty_id,
        myForm.pageState.bilty_ids
      )
    ) {
      debugger;
      myForm.setPageState({
        ...myForm.pageState,
        ["No"]: "",
        ["suffix"]: "",
      });
      myForm.setPreviousPageMode(myForm.pageMode);
      myForm.setPageMode("error");
      myForm.setPopupError("Already present");
      return;
    }
    let temp_info = temp_response;
    const newState = {
      bilty_ids: [temp_response, ...myForm.pageState["bilty_ids"]],
      ["No"]: "",
      ["suffix"]: "",
      // ["vehicle_no"] : bilty_ids[0].vehicle_no
    };

    if (process.env.REACT_APP_CLIENT == "xpress") {
      const url = SERVER_URL + "/vehicle/" + newState.bilty_ids[0].vehicle_no;
      const response = await fetch(url, { method: "GET" });

      const temp_response = await response.json();

      myForm.setPageState({
        ...myForm.pageState,
        ...newState,
        owner_name: temp_response.owner_name,
        driver_name: temp_response.driver_name,
        tds_rate: temp_response.tds_rate,
        pan_no: temp_response.pan_no,
        vehicle_no: newState.bilty_ids[0].vehicle_no,
        station_from_name: newState.bilty_ids[0].station_from_name,
        station_to_name: newState.bilty_ids[0].station_to_name,
        destination_name: newState.bilty_ids[0].destination_name,
        billing_party_name: newState.bilty_ids[0].billing_party_name,
      });

      const url1 = SERVER_URL + "/branch/" + temp_info.station_to;
      const res1 = await fetch(url1, { method: "GET" });
      const temp_response1 = await res1.json();

      const url2 = SERVER_URL + "/branch/" + temp_info.station_from;
      const res2 = await fetch(url2, { method: "GET" });
      const temp_response2 = await res2.json();

      const url3 = SERVER_URL + "/branch/" + temp_info.station_from;
      const res3 = await fetch(url3, { method: "GET" });
      const temp_response3 = await res3.json();

      // const url4 = SERVER_URL + "/branch/" + temp_info.billing_party_id
      // const res4 = await fetch(url4,{method:"GET"})
      // const temp_response4 = await res4.json()
    } else {
      myForm.setPageState({
        ...myForm.pageState,
        ...newState,
      });
    }

    if (process.env.REACT_APP_CLIENT == "nrab") {
      myForm.makeFocusOnParticularField("bilty_no");
    } else if (process.env.REACT_APP_CLIENT == "xpress") {
      myForm.makeFocusOnParticularField("weight");
    } else {
      myForm.makeFocusOnParticularField("bilty_type");
    }
  };

  const handleDelete = async () => {
    const fYear_fetch = JSON.parse(
      sessionStorage.getItem("financial_year_for_fetch")
    ).financial_year_for_fetch;
    const url =
      SERVER_URL +
      "/challan/?booking_chalan_no=" +
      myForm.pageState.challan_no +
      "&fyear=" +
      fYear_fetch +
      "&companyId=" +
      myForm.pageState.company_id;
    const response = await fetch(url, { method: "DELETE" });
    if (!response.ok) {
      return;
    }
    const temp_response = await response.json();
    if (temp_response.is_deleted) {
      myForm.setPageState({ ...dataObject, ...variablesFromSession });
      myForm.setPageMode("write");
      window.location.reload();
      return;
    }
  };

  const DatePopup = ({ onClose, onDateSelection }) => {
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(new Date().setHours(23, 59, 59, 0));

    const handleOKClick = () => {
      const endDate = toDate || new Date().setHours(23, 59, 59, 0);
      const dates = {
        fromDate: fromDate,
        toDate: endDate,
      };
      onDateSelection(dates);
      fetchDataTemp(dates);
      handleDateSelection(dates);
      onClose();
    };

    return (
      <div className="modal-overlay">
        <div className="modal">
          <label className="auto-fetch-style">
            From Date:
            {/* <DatePicker selected={fromDate}  dateFormat="dd-MM-yyy" onChange={(date) => setFromDate(date)} /> */}
            <input
              className="form-input-mr-statement-date"
              type="date"
              placeholder=""
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </label>
          <label className="auto-fetch-style">
            To Date:
            {/* <DatePicker selected={toDate} dateFormat="dd-MM-yyy"  onChange={(date) => setToDate(date)} /> */}
            <input
              className="form-input-mr-statement-date"
              type="date"
              placeholder=""
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </label>
          <button className="okButtonStyle" onClick={handleOKClick}>
            OK
          </button>
        </div>
      </div>
    );
  };

  const [isPopupVisible, setPopupVisible] = useState(false);
  //   const [selectedDates, setSelectedDates] = useState({
  //     fromDate: null,
  //     toDate: null,
  //   });

  const handleOpenPopup = () => {
    setPopupVisible(true);
  };

  const handleClosePopup = () => {
    setPopupVisible(false);
  };

  const handleDateSelection = (dates) => {
    // setSelectedDates(dates);
    console.log("Selected Dates:", dates);
  };

  const fetchDataTemp = async ({ fromDate, toDate }) => {
    const postData = {
      companyId: "1",
      destination: myForm.pageState.station_to.toString() || "",
      suffix: null,
      owned_by: sessionObject.sessionVariables.branch_id.toString(),
      module: "chalan",
      branch_id: sessionObject.sessionVariables.branch_id.toString(),
      fyear: sessionObject.sessionVariables.financial_year_for_fetch,
      flag: 0,
      from_date: new Date(
        new Date(fromDate).getTime() +
          0 * 60 * 60 * 1000 +
          0 * 60 * 1000 +
          1 * 1000
      ),
      to_date: new Date(
        new Date(toDate).getTime() +
          23 * 60 * 60 * 1000 +
          59 * 60 * 1000 +
          59 * 1000
      ),
    };

    myForm.setOverlay(true);
    const res = await fetch(SERVER_URL + "/bilty/multi_option", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": "token-value",
      },
      body: JSON.stringify(postData),
    });

    const data = await res.json();

    const filteredData = data.filter((item) => {
      return !myForm.pageState.bilty_ids.some(
        (existingItem) => existingItem.bilty_no === item.bilty_no
      );
    });
    const newState = {
      bilty_ids: [...filteredData],
    };

    myForm.setPageState({
      ...myForm.pageState,
      ...newState,
    });
    myForm.setOverlay(false);
  };

  const destFieldInfo = groupInfo["group-1"]?.find(f => f.name === "destination_name");
  const filteredGroup1 = destFieldInfo
    ? groupInfo["group-1"].filter(f => f.name !== "destination_name")
    : groupInfo["group-1"];

  const handleAddDestination = () => {
    const newIdx = destinationExtras.length;
    myForm.setPageStateByField(`destination_${newIdx}_name`, "");
    myForm.setPageStateByField(`destination_${newIdx}`, "");
    setDestinationExtras([...destinationExtras, {
      nameField: `destination_${newIdx}_name`,
      idField: `destination_${newIdx}`
    }]);
  };

  const handleRemoveDestination = (idx) => {
    const extra = destinationExtras[idx];
    myForm.setPageStateByField(extra.nameField, "");
    myForm.setPageStateByField(extra.idField, "");
    const newExtras = [...destinationExtras];
    newExtras.splice(idx, 1);
    setDestinationExtras(newExtras);
  };

  const renderAutosuggestField = (fieldInfo) => (
    <Autosuggest
      id={fieldInfo.name}
      suggestions={(myForm.suggestions != undefined) ? myForm.suggestions : ""}
      onSuggestionsFetchRequested={(a) => {
        if (fieldInfo.apiConfigKey) {
          myForm.onSuggestionsFetchRequestedDebounced(
            a,
            (b) => myForm.suggestionFetchApi(
              fieldInfo,
              b,
              getAdditionalInfoForSuggestionFetch(fieldInfo)
            )
          );
        }
      }}
      onSuggestionsClearRequested={() => myForm.onSuggestionsClearRequested(fieldInfo)}
      getSuggestionValue={(suggestion) => suggestion[fieldInfo.suggestionKeyword]}
      onSuggestionSelected={(a, b) =>
        myForm.getSuggestionValue(
          b.suggestion,
          fieldInfo,
          myForm.performSuggestions,
          myForm.updatePageStateForGetSuggestion
        )
      }
      renderSuggestion={(a) => myForm.renderSuggestion(a, fieldInfo)}
      highlightFirstSuggestion={true}
      ref={(a) => myForm.storeInputReference(a, false)}
      inputProps={{
        placeholder: fieldInfo["placeholder"],
        value: String(myForm.pageState[fieldInfo["name"]] || ""),
        onChange: (a, b) => {
          myForm.onChangeAutoSuggest(a, b, fieldInfo);
        },
        onBlur: () => fieldInfo["toValidate"] ? myForm.onblurValidator(fieldInfo) : {},
        onKeyPress: (a) => myForm.onKeyPressForKeyNav(a, fieldInfo, myForm.pageState),
        disabled: checkDisabledCondition(fieldInfo),
      }}
    />
  );

  const checkDisabledCondition = (fieldInfo) => {
    if (myForm.pageMode == "view") {
      return "disabled";
    } else if (fieldInfo.name == "cewb_no") {
      return "disabled";
    } else if (fieldInfo.name == "adv_bal") {
      return "disabled";
    }
    // else if (myForm.pageMode == "edit" && fieldInfo.name == "input_date") {
    //   return "disabled";
    // }
    else {
      return "";
    }
  };

  const checkVisibilityCondition = (fieldInfo) => {
    if (process.env.REACT_APP_CLIENT == "shubham") {
      if (fieldInfo.name == "party_rate") {
        const roleId = String(sessionObject.sessionVariables.role_id);
        if (roleId !== "1" || roleId == "2") {
          return false;
        }
      }
    }

    if (fieldInfo.name == "edit_button") {
      if (myForm.pageMode != "view") {
        return false;
      }

      if (myForm.pageState.is_inwarded != "1") {
        return true;
      }

      const roleId = sessionObject.sessionVariables.role_id;
      if (roleId == "1" || roleId == "2") {
        return true;
      }
      return false;
    }

    if (
      fieldInfo.name == "delete_button" &&
      myForm.pageState.is_inwarded == "1"
    ) {
      return false;
    }
    return true;
  };

  const handleAccountDetails = async () => {
    const no_challan = parseInt(myForm.pageState.challan_no);
    const url =
      SERVER_URL +
      `/bilty/get_account_details/?module=chalan&bilty_no=${no_challan}&fyear=${myForm.pageState.fYear}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Error fetching print data");
      }
      //
      const data = await response.json();
      let dataNew = [];
      for (let i = 0; i < data.length; i += 2) {
        //
        const temp_data = {
          // credit:data[i].data.credit,
          debit: data[i].data.debit,
          voucher_id: data[i].data.voucher_id,
          voucher_type: data[i].data.voucher_type,
          source_party_name: data[i].source_party_data.name,
          party_name: data[i].other_party_data.name,
          remarks: data[i].data.remarks,
        };
        dataNew.push(temp_data);
        // dataNew.push(data[i])
      }
      //
      setPrintData(dataNew);
      setPopupLoading(false);
    } catch (error) {
      console.error("Error fetching print data:", error);
      // Handle the error state here
    }
  };

  const takeInwardChallan = (row) => {
    let dummyObject = {
      multiple_popup: "0",
      multiple_popup_data: [],
    };
    myForm.setPageState({
      ...myForm.pageState,
      ...dummyObject,
    });
    let data = {
      apiUrlTail:
        row.booking_chalan_no + "?branch_id=" + myForm.pageState.created_from,
      apiType: "getChallan",
      apiConfig: challanApiConfig["getChallan"],
    };
    myForm.performSuggestions(data);
  };

  let newObj = {
    total_bilty: 0,
    total_pkgs: 0,
    total_weight: 0,
    total_eway: 0,
    total_amount: 0,
  };
  const [data, setData] = useState(newObj);
  useEffect(() => {
    for (let i = 0; i < myForm.pageState.bilty_ids.length; i++) {
      newObj.total_bilty += 1;
      newObj.total_pkgs +=
        parseInt(myForm.pageState.bilty_ids[i].no_of_package) || 0;
      newObj.total_weight +=
        parseInt(myForm.pageState.bilty_ids[i].charge_weight) || 0;
      newObj.total_eway +=
        myForm.pageState.bilty_ids[i]?.eway_bill_info?.length;
      newObj.total_amount += parseInt(
        myForm.pageState.bilty_ids[i].total_amount
      );
    }
    setData(newObj);
    myForm.setPageState({
      ...myForm.pageState,
      ...newObj,
    });
  }, [myForm.pageState.bilty_ids]);

  useEffect(() => {
    let newObj = {
      total: 0,
      balance_1: 0,
      adv_bal: 0,
      tds: 0,
    };

    let fields_add_in_tds = [
      myForm.pageState.lorry_hire,
      myForm.pageState.loading,
      myForm.pageState.detention,
      myForm.pageState.unloading,
      myForm.pageState.other,
      myForm.pageState.rto_charge,
    ];

    for (let i = 0; i < fields_add_in_tds.length; i++) {
      newObj.tds += parseInt(fields_add_in_tds[i] || 0);
    }

    newObj.tds *= parseInt(myForm.pageState.tds_rate || 0) / 100;
    newObj.tds = Math.round(newObj.tds, 0);

    let fields_to_add_in_total = [
      myForm.pageState.detention,
      myForm.pageState.hamali_charge,
      myForm.pageState.rto_charge,
      myForm.pageState.lorry_hire,
      myForm.pageState.loading,
      myForm.pageState.delivery_charge,
      myForm.pageState.height_charge,
    ];

    let fields_to_remove_from_total = [
      myForm.pageState.less_deduction,
      myForm.pageState.diesel_amount,
      myForm.pageState.advance1,
      myForm.pageState.advance2,
      myForm.pageState.advance3,
      myForm.pageState.advance4,
      myForm.pageState.advance5,
      myForm.pageState.balance_paid,
      myForm.pageState.tds,
    ];
    let fields_to_get_advance_balance = [
      myForm.pageState.advance1,
      myForm.pageState.advance2,
      myForm.pageState.advance3,
      myForm.pageState.advance4,
      myForm.pageState.advance5,
      myForm.pageState.balance_paid,
    ];

    let fields_to_add_in_balance = [
      myForm.pageState.lorry_hire,
      myForm.pageState.loading,
      myForm.pageState.detention,
      myForm.pageState.unloading,
      myForm.pageState.other,
      myForm.pageState.rto_charge,
      myForm.pageState.hamali_charge,
      myForm.pageState.hire_charge,
      myForm.pageState.container_charge,
      myForm.pageState.union_charge,
      myForm.pageState.unloading_detension_charge,
      myForm.pageState.incentive_charge,
      myForm.pageState.extra_point_charge,
      myForm.pageState.charge_weight,
    ];

    let fields_to_remove_from_balance = [
      myForm.pageState.advance1,
      myForm.pageState.advance2,
      myForm.pageState.advance3,
      myForm.pageState.advance4,
      myForm.pageState.advance5,
      myForm.pageState.balance_paid,
      myForm.pageState.claim_charge,
      myForm.pageState.late_delivery,
      myForm.pageState.commision,
      myForm.pageState.misc_income,
      myForm.pageState.office_mamul,
      myForm.pageState.other_expense,
      // myForm.pageState.tds,
      myForm.pageState.less_deduction,
    ];

    for (let i = 0; i < fields_to_add_in_total.length; i++) {
      newObj.total += parseInt(fields_to_add_in_total[i]) || 0;
    }

    for (let i = 0; i < fields_to_remove_from_total.length; i++) {
      newObj.total -= parseInt(fields_to_remove_from_total[i]) || 0;
    }
    for (let i = 0; i < fields_to_add_in_total.length; i++) {
      newObj.adv_bal += parseInt(fields_to_add_in_total[i]) || 0;
    }
    for (let i = 0; i < fields_to_get_advance_balance.length; i++) {
      newObj.adv_bal -= parseInt(fields_to_get_advance_balance[i]) || 0;
    }

    for (let i = 0; i < fields_to_add_in_balance.length; i++) {
      newObj.balance_1 += parseInt(fields_to_add_in_balance[i]) || 0;
    }

    for (let i = 0; i < fields_to_remove_from_balance.length; i++) {
      newObj.balance_1 -= parseInt(fields_to_remove_from_balance[i]) || 0;
    }

    if (myForm.pageState.weight > 0 && myForm.pageState.rate > 0) {
      newObj.lorry_hire =
        parseInt(myForm.pageState.weight) * parseInt(myForm.pageState.rate);
    }
    newObj.balance_1 -= newObj.tds;

    myForm.setPageState({
      ...myForm.pageState,
      ...newObj,
    });
  }, [
    myForm.pageState.rto_charge,
    myForm.pageState.hamali_charge,
    myForm.pageState.lorry_hire,
    myForm.pageState.charge_weight,
    myForm.pageState.loading,
    myForm.pageState.detention,
    // myForm.pageState.total,
    myForm.pageState.advance1,
    myForm.pageState.advance2,
    myForm.pageState.advance3,
    myForm.pageState.advance4,
    myForm.pageState.advance5,
    myForm.pageState.balance_paid,
    myForm.pageState.diesel_amount,
    myForm.pageState.commision,
    // myForm.pageState.balance_1,
    // myForm.pageState.balance_2,
    myForm.pageState.diesel_quantity,
    myForm.pageState.diesel_rate,
    myForm.pageState.less_deduction,
    myForm.pageState.delivery_charge,
    myForm.pageState.height_charge,
    myForm.pageState.claim_charge,
    myForm.pageState.late_delivery,
    myForm.pageState.misc_income,
    myForm.pageState.hire_charge,
    myForm.pageState.unloading,
    myForm.pageState.office_mamul,
    myForm.pageState.other_expense,
    myForm.pageState.container_charge,
    myForm.pageState.union_charge,
    myForm.pageState.unloading_detension_charge,
    myForm.pageState.incentive_charge,
    myForm.pageState.extra_point_charge,
    // myForm.pageState.tds,
    myForm.pageState.other,
    myForm.pageState.weight,
    myForm.pageState.rate,
    myForm.pageState.tds_rate,
  ]);

  // const calTds = () => {
  //     let tds = 0;
  //     let fields_add_in_tds = [
  //         myForm.pageState.lorry_hire,
  //         myForm.pageState.loading,
  //         myForm.pageState.detention,
  //         myForm.pageState.other,
  //         myForm.pageState.unloading,
  //         myForm.pageState.rto_charge,
  //     ];

  //     for (let i = 0; i < fields_add_in_tds.length; i++) {
  //         tds += parseInt(fields_add_in_tds[i] || 0);
  //     }

  //     tds *= parseInt(myForm.pageState.tds_rate || 0) / 100;
  //     return tds;
  // }

  // if(process.env.REACT_APP_CLIENT == "xpress") {
  //     // useEffect(() => {
  //     //     let newObj = {
  //     //         tds: 0,
  //     //     }
  //     //     newObj.tds =
  //     //     Math.round(
  //     //         (parseInt(myForm.pageState.lorry_hire || 0) +
  //     //             parseInt(myForm.pageState.loading || 0) +
  //     //             parseInt(myForm.pageState.detention || 0) +
  //     //             parseInt(myForm.pageState.other || 0) +
  //     //             parseInt(myForm.pageState.unloading || 0) +
  //     //             parseInt(myForm.pageState.rto_charge || 0)) *
  //     //         (parseInt(myForm.pageState.tds_rate || 0) / 100)
  //     //     );
  //     //     myForm.setPageState({
  //     //         ...myForm.pageState, ...newObj
  //     //     })
  //     // },[
  //     //     myForm.pageState.lorry_hire,
  //     //     myForm.pageState.loading,
  //     //     myForm.pageState.detention,
  //     //     myForm.pageState.other,
  //     //     myForm.pageState.unloading,
  //     //     myForm.pageState.rto_charge,
  //     //     myForm.pageState.tds_rate,
  //     // ])

  //     let temp_tds = 0;
  //     useEffect(() => {
  //       temp_tds = calTds()

  //       myForm.setPageState({
  //         ...myForm.pageState,
  //         ["tds"]:temp_tds
  //     })

  //     }, [
  //         // myForm.pageState.lorry_hire,
  //         // myForm.pageState.loading,
  //         // myForm.pageState.detention,
  //         // myForm.pageState.other,
  //         // myForm.pageState.unloading,
  //         // myForm.pageState.rto_charge,
  //         myForm.pageState.tds_rate,
  //     ])

  // }

  // useEffect(() => {
  //     let newObj = {
  //         lorry_hire:0
  //     }

  //     myForm.setPageState({
  //         ...myForm.pageState, ...newObj
  //     })

  // }, [])

  const formatDateToDDMMYYYY = (dateString) => {
    const [datePart] = dateString.split(" ");
    const [day, month, year] = datePart.split("/");
    const date = new Date(`${year}-${month}-${day}`);
    if (isNaN(date)) {
      return null;
    }
    return `${day}/${month}/${year}`;
  };

  const handlePrintCewb = async () => {
    myForm.setOverlay(true);
    const url = `${SERVER_URL}/ewb/get_cewb_print_json?cewb_number=${myForm.pageState.cewb_no}`;

    try {
      let response = await fetch(url);
      if (!response.ok) {
        throw new Error("Failed to fetch CEWB data");
      }

      const jsonData = await response.json();
      jsonData.cewb_date = jsonData.cewb_date
        ? formatDateToDDMMYYYY(jsonData.cewb_date)
        : null;

      const modifiedData = jsonData.data.map((item, index) => ({
        ...item,
        sr_no: index + 1,
        ewb_date: item.ewb_date ? formatDateToDDMMYYYY(item.ewb_date) : null,
      }));

      jsonData.data = modifiedData;

      const printResponse = await fetch(
        `${NEW_PRINT}/bilty/print_table/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(jsonData),
        }
      );

      if (!printResponse.ok) {
        throw new Error("Failed to print the table");
      }

      const blobData = await printResponse.blob();

      if (blobData.size === 0) {
        throw new Error("Blob is empty, cannot print");
      }

      const blobUrl = URL.createObjectURL(blobData);
      console.log("Blob URL created:", blobUrl);

      print({ printable: blobUrl, type: "pdf", showModal: false });
    } catch (error) {
      console.error("Error:", error);
    } finally {
      myForm.setOverlay(false);
    }
  };

  return (
    <div className="challan-form-container">
      {USE_OVERLAY && (
        <LoadingOverlay
          active={myForm.overlay}
          spinner
          text="Loading your content..."
          styles={{
            wrapper: {
              // width: '400px',
              // height: '400px',
              overflow: true ? "hidden" : "scroll",
            },
          }}
        ></LoadingOverlay>
      )}
      <div>
        <div>
          <Popup
            open={myForm.pageState.fyearList.length > 0}
            modal
            closeOnDocumentClick={false}
          >
            {(close) => myForm.displayFyearPopup(close)}
          </Popup>
        </div>
        <div>
          <Popup
            // trigger={<button className="button"> Open Modal </button>}
            open={checkCwbSubmitted}
            modal
            contentStyle={contentStyle}
            closeOnDocumentClick={false}
          >
            {(close) => (
              <div className="pop-up-container">
                <div className="pop-up-header">
                  {" "}
                  <div> Result of check EWB </div>
                  <div>
                    <a className="pop-up-close btn" onClick={close}>
                      &times;
                    </a>
                  </div>
                </div>
                <div className="pop-up-content">
                  Information:
                  <br />
                  <div className="pop-up-fields">
                    {Object.keys(checkCwbResult).map((key) => {
                      let obj = checkCwbResult[key];
                      return (
                        <div>
                          <div className="pop-up-field">
                            <div className="pop-up-field-label">
                              {" "}
                              Docket No:{" "}
                            </div>
                            <div className="pop-up-field-value">
                              {" "}
                              {obj.bilty_no}{" "}
                            </div>
                          </div>
                          <div className="pop-up-field">
                            <div className="pop-up-field-label">
                              {" "}
                              EWay bill No:{" "}
                            </div>
                            <div className="pop-up-field-value">
                              {" "}
                              {obj.eway_bill_no}{" "}
                            </div>
                          </div>
                          <hr />
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div className="pop-up-actions">
                  <button
                    className="pop-up-button"
                    onClick={() => {
                      setcheckCwbSubmitted(false);
                      close();
                    }}
                  >
                    Okay
                  </button>
                </div>
              </div>
            )}
          </Popup>
          <Popup
            // trigger={<button className="button"> Open Modal </button>}
            open={myForm.pageMode == "submitted" || myForm.pageMode == "error"}
            modal
            contentStyle={contentStyle}
            closeOnDocumentClick={false}
          >
            {(close) => (
              <div className="pop-up-container">
                <div className="pop-up-header">
                  {" "}
                  {myForm.pageMode == "submitted" ? (
                    <div>{popupInfo.success_header}</div>
                  ) : (
                    <div>{popupInfo.error_header}</div>
                  )}
                  <div>
                    <a className="pop-up-close btn" onClick={close}>
                      &times;
                    </a>
                  </div>
                </div>
                {myForm.pageMode == "submitted" ? (
                  <div className="pop-up-content">
                    {popupInfo.success_title}
                    <br />
                    <div className="pop-up-fields">
                      <div className="pop-up-field">
                        <div className="pop-up-field-label">
                          {popupInfo.field_label_success}
                        </div>
                        <div className="pop-up-field-value">
                          {myForm.pageState[popupInfo.field_name_success]}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="pop-up-content">
                    {popupInfo.error_title}
                    <br />
                    <div className="pop-up-fields">
                      <div className="pop-up-field">
                        <div className="pop-up-field-label">
                          {popupInfo.field_label_error}
                        </div>
                        <div className="pop-up-field-value">
                          {myForm.popupError}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div className="pop-up-actions">
                  <button
                    className="pop-up-button"
                    onClick={() => {
                      if (myForm.pageMode == "submitted") {
                        // sessionObject.saveSessionVariableByField("last_bilty_no", {"last_bilty_no":myForm.pageState.bilty_no})
                        myForm.setPageState({
                          ...dataObject,
                          ...variablesFromSession,
                        });
                        myForm.setPageMode("write");
                        window.location.reload();
                        close();
                      } else {
                        if (myForm.previousPageMode != "") {
                          myForm.setPageMode(myForm.previousPageMode);
                          myForm.setPreviousPageMode("");
                        } else {
                          myForm.setPageMode("write");
                        }
                        close();
                      }
                    }}
                  >
                    Okay
                  </button>
                </div>
              </div>
            )}
          </Popup>
        </div>
        <div>
          <Popup
            // trigger={<button className="button"> Open Modal </button>}
            open={myForm.deletePopup}
            modal
            contentStyle={contentStyle}
            closeOnDocumentClick={false}
          >
            {(close) => (
              <div className="pop-up-container">
                <div className="pop-up-header">
                  Are you sure want to delete?
                </div>
                <div className="pop-up-actions">
                  <button
                    className="pop-up-button"
                    onClick={() => {
                      handleDelete();
                      myForm.setDeletePopup(false);
                      close();
                      window.location.reload();
                    }}
                  >
                    Yes
                  </button>
                  <button
                    className="pop-up-button"
                    onClick={() => {
                      myForm.setDeletePopup(false);
                      close();
                    }}
                  >
                    No
                  </button>
                </div>
              </div>
            )}
          </Popup>
        </div>
        <div>
          <Popup
            // trigger={<button className="button"> Open Modal </button>}
            open={myForm.pageState.multiple_popup == "1"}
            modal
            contentStyle={contentStyle}
            closeOnDocumentClick={false}
          >
            {(close) => (
              <div className="pop-up-container">
                <div className="pop-up-header">
                  {" "}
                  Multiple Loading Sheet Found With Same Manual No
                </div>
                <div className="pop-up-content">
                  <table>
                    <thead>
                      <tr>
                        <td>Loading Sheet No</td>
                        <td>Branch</td>
                        <td>Take Inward</td>
                      </tr>
                    </thead>
                    <tbody>
                      {myForm.pageState.multiple_popup_data.map((row) => (
                        <tr>
                          <td>{row.booking_chalan_no}</td>
                          <td>{row.branch_name}</td>
                          <td>
                            <button
                              onClick={() => {
                                takeInwardChallan(row);
                              }}
                            >
                              Get
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="pop-up-actions">
                  <button
                    className="pop-up-button"
                    onClick={() => {
                      if (myForm.pageMode == "submitted") {
                        // sessionObject.saveSessionVariableByField("last_bilty_no", {"last_bilty_no":myForm.pageState.bilty_no})
                        myForm.setPageState({
                          ...ChallanInwardDataObject,
                          ...variablesFromSession,
                        });
                        myForm.setPageMode("write");
                        window.location.reload();
                        close();
                      } else {
                        myForm.setPageMode("write");
                        close();
                      }
                    }}
                  >
                    Okay
                  </button>
                </div>
              </div>
            )}
          </Popup>
        </div>
      </div>
      <div className="form-header">Loading Sheet</div>
      <div
        onSubmit={myForm.handleSubmit}
        className="form"
        noValidate
        style={{ overflow: "auto" }}
      >
        <div className="form-title">
          {process.env.REACT_APP_CLIENT_NAME == "CHAMUNDA LOGISTICS" && (
            <button
              onClick={() => {
                handleAccountDetails(), setIsPrint(true);
              }}
            >
              Account Details
            </button>
          )}
          <div>
            <Popup open={isPrint} modal closeOnDocumentClick={false}>
              {(close) => (
                <div className="pop-up-container">
                  <div className="pop-up-header">
                    {popupLoading ? (
                      <div>Loading...</div>
                    ) : (
                      <>
                        <div style={{ maxHeight: "400px", overflow: "auto" }}>
                          <DynamicViewTable
                            checkBox={0}
                            tableHeader={accountDetailTableHeader}
                            tableItems={accountDetailTableItems}
                            tableValues={printData}
                            // setPageStateByField={myForm.setPageStateByField}
                            pageStateArray={printData}
                            // deleteEntryFromTableCallback={deleteEntryFromTableCallback}
                            handleCheckboxChange={handleCheckboxChangeRR}
                            fieldMapping="bilty_ids"
                            getSelectAllValue={getSelectAllValueRR}
                            selectAll={selectAllRR}
                            deselectAll={deselectAllRR}
                          />
                        </div>
                      </>
                    )}
                  </div>

                  <div className="rr-pop-up-actions">
                    <button
                      className="pop-up-button"
                      id="yes_button"
                      onClick={() => {
                        setIsPrint(false);
                        close();
                      }}
                    >
                      Close
                    </button>
                    {/* <button
                    className="pop-up-button"
                    id="yes_button"
                    onClick={() => {
                        setIsPrint(false);
                        setIsStopRR(true);
                        close();
                    }}
                  >
                    Stop
                  </button>
                        <ReactHTMLTableToExcel
                            id="test-table-xls-button"
                            className="btn btn-primary"
                            table="account_report_excel_bilty"
                            filename="account_without_bilty"
                            sheet="tablexls"
                            buttonText="Download"
                          />
                          {ReportExcel.account_without_bilty_excel(
                            printData
                          )} */}
                  </div>
                </div>
              )}
            </Popup>
          </div>

          <div className="form-row">
            <div>
              <label className="form-label">Loading Sheet No:</label>
              <input
                id="size"
                className="form-input"
                type="text"
                name="challan_no"
                placeholder=""
                value={myForm.pageState.challan_no}
                onChange={myForm.handleChange}
                onBlur={() => {}}
                onKeyPress={(a) =>
                  myForm.getFyearsOnKeyEnter(
                    a,
                    "Challan",
                    myForm.pageState.challan_no
                  )
                }
                ref={(a) =>
                  myForm.storeInputReferenceForSelect(a, "challan_no")
                }
                disabled={checkDisabledCondition({ name: "challan_no" })}
              />
            </div>
            {process.env.REACT_APP_CLIENT !== "gdala_cargo" ? (
              <div className="move">
                <label className="form-label">Manual No:</label>
                <input
                  id="size"
                  className="form-input"
                  type="text"
                  name="manual_no"
                  placeholder=""
                  value={myForm.pageState.manual_no}
                  onChange={myForm.handleChange}
                  onBlur={() => {}}
                  onKeyPress={(a) =>
                    myForm.getPageOnKeyEnter(a, myForm.pageState.manual_no)
                  }
                  ref={(a) =>
                    myForm.storeInputReferenceForSelect(a, "manual_no")
                  }
                  disabled={checkDisabledCondition({ name: "manual_no" })}
                />
              </div>
            ) : (
              ""
            )}

            {myForm.internalValidationErrors["challan_no"] && (
              <p>{myForm.internalValidationErrors["challan_no"]}</p>
            )}
            {checkVisibilityCondition({ name: "edit_button" }) && (
              <>
                <button
                  onClick={() => {
                    myForm.setPageMode("edit");
                  }}
                >
                  Edit
                </button>
                {/* <button
                  onClick={() => {
                    myForm.setPageState({
                      ...dataObject,
                      ...variablesFromSession,
                    });
                    window.location.reload();
                    myForm.setPageMode("write");
                  }}
                >
                  Clear
                </button> */}
                {/* <button onClick={handleDelete}>Delete</button> */}
              </>
            )}
            {process.env.REACT_APP_CLIENT != "nrab" && (
              <label id="challan-checkbox">
                <input
                  type="checkbox"
                  defaultChecked={checked}
                  checked={myForm.pageState.is_crossing_challan}
                  onChange={handleChangeCheckbox}
                  value={myForm.pageState["is_crossing_challan"]}
                />
                Is Crossing Loading Sheet?
              </label>
            )}
          </div>
          {myForm.pageState.is_inwarded == "1" && (
            <div className="form-row" style={{ margin: "10px" }}>
              <label className="form-label">Inward Done</label>
            </div>
          )}
          {
            <div className="form-row">
              <label className="form-label">
                Trip No: {myForm.pageState.trip_no}
              </label>
            </div>
          }
          <div>
            Loading Sheet Date:{" "}
            <DatePicker
              dateFormat="dd-MM-yyy"
              selected={myForm.pageState.input_date}
              onChange={(date) =>
                myForm.setPageStateByField("input_date", date)
              }
              ref={(a) => myForm.storeInputReferenceForSelect(a, "input_date")}
              disabled={checkDisabledCondition({ name: "input_date" })}
              onKeyPress={(a) => {
                console.log("Here");
                // if (a.key == "Enter"){
                //   myForm.makeFocusOnParticularFieldForItem("eway_bill_no", 0, "eway_bill_no");
                // }
              }}
            />
          </div>
          <div className="form-row">
            <label className="form-last_bilty">Last Loading Sheet No:</label>
            <label className="form-last_bilty">
              {myForm.pageState.last_challan_no}
            </label>
          </div>
        </div>
        <div className="form-input-content-block-0">
          <div className="form-field-left">
            <FormColumn
              groupInfo={{...groupInfo, "group-1": filteredGroup1}}
              groupName="group-1"
              checkDisabledCondition={checkDisabledCondition}
              checkVisibilityCondition={checkVisibilityCondition}
              myFormObj={myForm}
              getAdditionalInfoForSuggestionFetch={
                getAdditionalInfoForSuggestionFetch
              }
            />
            {destFieldInfo && (() => {
              const nextFieldAfterDest = destFieldInfo.keyboardNavigationMap.Enter;
              const mainFieldInfo = {
                ...destFieldInfo,
                keyboardNavigationMap: {
                  conditionalNav: true,
                  conditionalNavFunct: () => {
                    if (destinationExtras.length > 0) {
                      return destinationExtras[0].nameField;
                    }
                    return nextFieldAfterDest;
                  },
                },
              };
              return (
                <div className="form-row" key="destination_main">
                  <label className="form-label">
                    {destFieldInfo.label}
                    <button
                      type="button"
                      className="add-destination-btn"
                      onClick={handleAddDestination}
                      title="Add destination"
                      style={{marginLeft: "8px", cursor: "pointer"}}
                    >+</button>
                  </label>
                  {renderAutosuggestField(mainFieldInfo)}
                  {myForm.internalValidationErrors["destination_name"] && (
                    <p>{myForm.internalValidationErrors["destination_name"]}</p>
                  )}
                </div>
              );
            })()}
            {destFieldInfo && (() => {
              const nextFieldAfterDest = destFieldInfo.keyboardNavigationMap.Enter;
              return destinationExtras.map((extra, idx) => {
                const extraFieldInfo = {
                  ...destFieldInfo,
                  name: extra.nameField,
                  suggestionSchema: {
                    branch_id: extra.idField,
                    name: extra.nameField,
                  },
                  keyboardNavigationMap: {
                    conditionalNav: true,
                    conditionalNavFunct: () => {
                      const nextIdx = idx + 1;
                      if (nextIdx < destinationExtras.length) {
                        return destinationExtras[nextIdx].nameField;
                      }
                      return nextFieldAfterDest;
                    },
                  },
                };
                return (
                  <div className="form-row" key={extra.nameField}>
                    <label className="form-label">
                      Destination {idx + 1}
                      <button
                        type="button"
                        className="remove-destination-btn"
                        onClick={() => handleRemoveDestination(idx)}
                        title="Remove destination"
                        style={{marginLeft: "8px", cursor: "pointer"}}
                      >-</button>
                    </label>
                    {renderAutosuggestField(extraFieldInfo)}
                  </div>
                );
              });
            })()}
          </div>
          <div className="form-field-right">
            <FormColumn
              groupInfo={groupInfo}
              groupName="group-2"
              checkDisabledCondition={checkDisabledCondition}
              checkVisibilityCondition={checkVisibilityCondition}
              myFormObj={myForm}
              getAdditionalInfoForSuggestionFetch={
                getAdditionalInfoForSuggestionFetch
              }
            />
          </div>
        </div>
        <div className="chform-row">
          <div className="type-bilty">
            {process.env.REACT_APP_CLIENT !== "shubham" && (
              <button onClick={handleOpenPopup}>Auto Fetch</button>
            )}
            {isPopupVisible && (
              <DatePopup
                onClose={handleClosePopup}
                onDateSelection={handleDateSelection}
              />
            )}
            {process.env.REACT_APP_CLIENT_NAME != "ASHAPURA TRANSPORT" && (
              <label className="chform-label">Type</label>
            )}
            {process.env.REACT_APP_CLIENT_NAME != "ASHAPURA TRANSPORT" && (
              <select
                className="chform-input-suffix"
                onChange={(newValue) => {
                  myForm.handleChangeForSelect(newValue, "bilty_type");
                }}
                ref={(a) =>
                  myForm.storeInputReferenceForSelect(a, "bilty_type")
                }
                disabled={checkDisabledCondition({ name: "bilty_type" })}
                value={myForm.pageState["bilty_type"]}
                onKeyPress={(a) => {
                  if (a.key == "Enter") {
                    a.preventDefault();
                    myForm.makeFocusOnParticularField("bilty_no");
                  }
                }}
              >
                <option value="D" key="D">
                  D
                </option>
                <option value="C" key="C">
                  C
                </option>
              </select>
            )}
          </div>

          <div className="type-bilty">
            <label className="chform-label">Docket No:</label>
            <input
              className="chform-input"
              type="text"
              name="No"
              placeholder=""
              value={myForm.pageState["No"]}
              onChange={myForm.handleChange}
              // onKeyPress={(a) => {
              //     if (a.key == "Enter") {
              //         myForm.makeFocusOnParticularField("suffix");
              //     }
              // }}
              onKeyPress={(e) => {
                if (e.key == "Enter") {
                  if (myForm.pageState["No"]) {
                    getFyearsOnKeyEnter(
                      e,
                      "Bilty Inquiry",
                      myForm.pageState.No
                    );
                  } else {
                    if (parseInt(process.env.REACT_APP_CHALLAN_FTL_MODE) == 0) {
                      myForm.makeFocusOnParticularField("save_button");
                    }
                    if (process.env.REACT_APP_CLIENT == "jkl") {
                      myForm.makeFocusOnParticularField("save_button");
                    } else {
                      myForm.makeFocusOnParticularField("lorry_hire");
                    }
                  }
                }
              }}
              ref={(a) => myForm.storeInputReferenceForSelect(a, "bilty_no")}
            />
            <select
              className="chform-input "
              name="suffix"
              value={myForm.pageState.suffix}
              onChange={(e) => myForm.handleChangeForSelect(e, "suffix")}
              onKeyPress={(e) => {
                if (e.key == "Enter") {
                  e.preventDefault();
                  linkBilty(e);
                }
              }}
              ref={(a) => myForm.storeInputReferenceForSelect(a, "suffix")}
            >
              {myForm.pageState.suffix_options.map((suff) => {
                return <option value={suff}> {suff} </option>;
              })}
            </select>
          </div>
          <div className="type-bilty">
            {/* <label className="chform-label">Station To:</label>
            <input
              className="chform-input"
              type="text"
              name="station_to"
              placeholder=""
              value={stationTo}
              onChange={(e) => handleStationToChange(e)}
            /> */}
            <FormColumn
              groupInfo={groupInfo}
              groupName="group-6"
              checkDisabledCondition={checkDisabledCondition}
              checkVisibilityCondition={checkVisibilityCondition}
              myFormObj={myForm}
              getAdditionalInfoForSuggestionFetch={
                getAdditionalInfoForSuggestionFetch
              }
            />
          </div>
        </div>

        <div className="table-container">
          <DynamicViewTable
            // checkBox={1}
            tableHeader={challanBiltyOriginalTableHeader}
            tableItems={challanBiltyOriginalTableItems}
            tableValues={myForm.pageState["bilty_ids"]}
            setPageStateByField={myForm.setPageStateByField}
            pageStateArray={myForm.pageState["bilty_ids"]}
            fieldMapping="bilty_ids"
          />
        </div>
        <div className="form-footer">
          <label>{"Total Docket:- " + data.total_bilty + "    ,"}</label>
          <label>{"Total Pkgs:- " + data.total_pkgs + "    ,"}</label>
          <label>{"Total Weight:- " + data.total_weight + "    ,"}</label>
          <label>{"Total EWay:- " + data.total_eway + "    ,"}</label>
          <label>{" Total Amount:- " + data.total_amount + "    "}</label>
        </div>
        {parseInt(process.env.REACT_APP_CHALLAN_FTL_MODE) == 1 && (
          <div className="form-input-content-block-0">
            <div className="form-field-left">
              <FormColumn
                groupInfo={groupInfo}
                groupName="group-3"
                checkDisabledCondition={checkDisabledCondition}
                checkVisibilityCondition={checkVisibilityCondition}
                myFormObj={myForm}
                getAdditionalInfoForSuggestionFetch={
                  getAdditionalInfoForSuggestionFetch
                }
              />
            </div>
            <div className="form-field-right">
              <FormColumn
                groupInfo={groupInfo}
                groupName="group-4"
                checkDisabledCondition={checkDisabledCondition}
                checkVisibilityCondition={checkVisibilityCondition}
                myFormObj={myForm}
                getAdditionalInfoForSuggestionFetch={
                  getAdditionalInfoForSuggestionFetch
                }
              />
            </div>
            <div className="form-field-right">
              <FormColumn
                groupInfo={groupInfo}
                groupName="group-5"
                checkDisabledCondition={checkDisabledCondition}
                checkVisibilityCondition={checkVisibilityCondition}
                myFormObj={myForm}
                getAdditionalInfoForSuggestionFetch={
                  getAdditionalInfoForSuggestionFetch
                }
              />
            </div>
          </div>
        )}

        <div className="form-footer">
          <button
            onClick={(e) => {
              myForm.setServerPrintNeeded(true);
              myForm.handleSubmit(e);
            }}
            type="button"
            className="btn btn-primary"
          >
            Print
          </button>
          <button
            onClick={myForm.handleSubmit}
            type="button"
            className="btn btn-primary"
            ref={(a) => myForm.storeInputReferenceForSelect(a, "save_button")}
          >
            Save
          </button>
          {checkVisibilityCondition({ name: "delete_button" }) && (
            <button onClick={() => myForm.setDeletePopup(true)} className="btn btn-primary">Delete</button>
          )}
          <button
            onClick={() => {
              history.push("/");
            }}
            className="btn btn-primary"
          >
            Exit
          </button>
          <button
            onClick={() => {
              myForm.setPageState({
                ...dataObject,
                ...variablesFromSession,
              });
              window.location.reload();
              myForm.setPageMode("write");
            }}
            className="btn btn-primary"
          >
            New
          </button>

          {myForm.pageState.status == "1" && (
            <button
              onClick={() => {
                let data = {
                  apiUrlTail:
                    myForm.pageState.challan_no +
                    "?companyId=" +
                    myForm.pageState.company_id +
                    "&fyear=" +
                    JSON.parse(
                      sessionStorage.getItem("financial_year_for_fetch")
                    ).financial_year_for_fetch,
                  apiType: "generateCwb",
                  apiConfig: challanApiConfig["generateCwb"],
                };
                myForm.setOverlay(true);
                myForm.performSuggestions(data);
              }}
              className="btn btn-primary"
            >
              Genrate CWB
            </button>
          )}

          {myForm.pageState.status == "1" && (
            <button onClick={handlePrintCewb} className="btn btn-primary">Print CEWB</button>
          )}
          {myForm.pageState.status == "1" && (
            <button
              onClick={async () => {
                const fYear_fetch = JSON.parse(
                  sessionStorage.getItem("financial_year_for_fetch")
                ).financial_year_for_fetch;
                myForm.setOverlay(true);
                const url =
                  SERVER_URL +
                  "/ewb/canceled/" +
                  myForm.pageState.challan_no +
                  `?branch_id=${myForm.pageState.created_from}` +
                  `&direct_govt=${0}` +
                  "&fyear=" +
                  fYear_fetch +
                  "&companyId=" +
                  myForm.pageState.company_id;
                const resp = await fetch(url);
                if (!resp.ok) {
                  myForm.setPageMode("error");
                  myForm.setPopupError("Something went wrong!");
                  return;
                }
                const data = await resp.json();
                checkCwbResult = data;
                console.log({ data });
                setcheckCwbSubmitted(true);
                myForm.setOverlay(false);
              }}
              className="btn btn-primary"
            >
              Check EWB
            </button>
          )}

          {/* <div className="status">{myForm.renderSubmitApiResponseStatus()}</div> */}
        </div>
      </div>
    </div>
  );
};

export default ChallanForm;
